<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <ModelTitle title="Classroom Report Card" @close="close" />
        <v-card-text>
          <v-select
            v-model="selectedYear"
            :items="years"
            item-text="name"
            return-object
            outlined
            dense
            label="Select Year"
          />

          <v-checkbox
            v-model="forceRegenerate"
            class="mt-3"
            hide-details
            label="Force regenerate report card"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            :disabled="!selectedYear"
            :loading="loading"
            @click="generate"
          >
            Generate Report Cards
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showPdf"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card class="d-flex flex-column" style="height: 100vh">
        <v-toolbar flat>
          <v-toolbar-title>Classroom Report Cards</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <embed :src="pdf" type="application/pdf" width="100%" height="100%" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake.min";
import { pdfMake as pdfFonts } from "pdfmake/build/vfs_fonts";
import yearService from "@/modules/ReportCard/Year/service";
import classRoomService from "@/modules/ClassRoom/service";

pdfMake.vfs = pdfFonts.vfs;

export default {
  name: "classroom-report-card",
  props: {
    ClassRoom: Object,
  },

  data() {
    return {
      dialog: true,
      loading: false,
      showPdf: false,
      pdf: null,
      years: [],
      selectedYear: null,
      forceRegenerate: false,
    };
  },

  mounted() {
    this.getYears();
  },

  beforeDestroy() {
    this.clearPdfUrl();
  },

  methods: {
    clearPdfUrl() {
      if (this.pdf) {
        URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },

    close() {
      this.clearPdfUrl();
      this.dialog = false;
      this.showPdf = false;
      this.$emit("close");
    },

    async getYears() {
      try {
        const res = await yearService.getAll({
          filteredClasses: [this.ClassRoom.ClassId],
        });
        this.years = res.data || [];
      } catch (error) {
        console.log("error getting years", error);
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title:
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              "Unable to load years",
          });
      }
    },

    async generate() {
      try {
        this.loading = true;

        const res = await classRoomService.generateClassroomReportCard({
          ClassRoomId: this.ClassRoom.id,
          YearId: this.selectedYear.id,
          forceRegenerate: this.forceRegenerate,
        });

        const docDefinition =
          res?.data?.docDefinition ||
          res?.docDefinition ||
          res?.data?.data?.docDefinition ||
          null;

        if (!docDefinition) {
          throw new Error("No report definition returned from server");
        }

        this.clearPdfUrl();

        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          this.pdf = URL.createObjectURL(blob);
          this.showPdf = true;
          this.dialog = false;
          this.loading = false;
        });
      } catch (error) {
        console.log("generate report card error", error);
        this.loading = false;

        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title:
              error?.response?.data?.message ||
              error?.message ||
              "Unable to generate report card",
          });
      }
    },
  },
};
</script>